__turbopack_context__.v({
  "icon": "VerifyBrc20-module__Xyqfbq__icon",
  "root": "VerifyBrc20-module__Xyqfbq__root",
});
